if (!customElements.get('learn-more-modal-dialog')) {
    customElements.define('learn-more-modal-dialog', class LearnMoreModalDialog extends ModalDialog {
        static selectors = {
            learnMoreSourceMobile: ".js-upsell-products-learn-modal-source-mobile",
            learnMoreImage: ".js-upsell-products-learn-modal-image",
            learnMoreClose: ".js-learn-more-modal-close"
        }

        constructor() {
            super();
            this.showLearnMoreModal = this.showLearnMoreModal.bind(this);
            this.initCloseButton();
        }

        initCloseButton() {
            this.closeButton = this.querySelector(LearnMoreModalDialog.selectors.learnMoreClose);
            if (this.closeButton) {
                this.closeButton.addEventListener('click', this.hide.bind(this));
            }

            const image = this.querySelector(LearnMoreModalDialog.selectors.learnMoreImage);
            if (image) {
                image.style.cursor = 'pointer';
                image.addEventListener('click', this.hide.bind(this));
            }
        }

        show(opener) {
            this.showLearnMoreModal(opener);
            super.show(opener);
        }

        showLearnMoreModal(opener) {
            const learnMoreButton = opener;
            const modal = this;

            if (!learnMoreButton || !modal) return;

            const img = modal.querySelector(LearnMoreModalDialog.selectors.learnMoreImage);
            const mobileSource = modal.querySelector(LearnMoreModalDialog.selectors.learnMoreSourceMobile);

            const desktop1x = learnMoreButton.dataset.imageDesktop1x;
            const desktop2x = learnMoreButton.dataset.imageDesktop2x;
            const mobile1x = learnMoreButton.dataset.imageMobile1x || learnMoreButton.dataset.imageDesktop1x;
            const mobile2x = learnMoreButton.dataset.imageMobile2x || learnMoreButton.dataset.imageDesktop2x;
            const alt = learnMoreButton.dataset.imageAlt || '';

            if (mobileSource) {
                if (mobile1x && mobile2x) {
                    mobileSource.srcset = `${mobile1x} 1x, ${mobile2x} 2x`;
                } else if (mobile1x) {
                    mobileSource.srcset = mobile1x;
                }
            }

            if (img) {
                img.src = desktop1x || mobile1x;

                if (desktop1x && desktop2x) {
                    img.srcset = `${desktop1x} 1x, ${desktop2x} 2x`;
                } else if (desktop1x) {
                    img.srcset = desktop1x;
                } else {
                    img.removeAttribute('srcset');
                }

                if (alt) {
                    img.alt = alt;
                }
            }
        }
    });
}
